import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import type { IndicatorSelectHandler } from '../../model/useIndicatorTransitions';
import { DASHBOARD_BLOCK_SCROLL_CLASS } from '../utils';
import { BarChart, BarChartItem } from './BarChart';

type Props = {
  title: string;
  items: BarChartItem[];
  /** Максимум шкалы для нормировки баров; не задан — каждый бар нормируется своей долей или своим максимумом. */
  maxValue?: number;
  negative?: boolean;
  /** Переход к диалогам строки; не задан — строки остаются некликабельными */
  onSelect?: IndicatorSelectHandler;
  /** true — ограничить высоту диаграммы единым потолком блоков ряда с внутренним скроллом. */
  capHeight?: boolean;
};

/** Карточка с заголовком и горизонтальной столбчатой диаграммой. */
export const BarChartCard: FC<Props> = ({ title, items, maxValue, negative, onSelect, capHeight }) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent>
      <div className={capHeight ? DASHBOARD_BLOCK_SCROLL_CLASS : undefined}>
        <BarChart items={items} maxValue={maxValue} negative={negative} onSelect={onSelect} />
      </div>
    </CardContent>
  </Card>
);
